import React from 'react';

import { IBaseProps } from '@rbi-ctg/frontend';

export enum ModalSize {
  FULLSCREEN = 'FULLSCREEN',
  REGULAR = 'REGULAR',
  SMALL = 'SMALL',
  LANDSCAPE = 'LANDSCAPE',
}

export interface IAmplitudeEventData {
  /**
   * A small string sent to amplitude describing the purpose of the modal.
   */
  modalAppearanceEventMessage: string;
  /**
   * Modal header shown to user.
   * Usually you will not need to provide this value since the modal header
   * will be deduced from the modal-heading ID or the heading tag.
   * Only provide this value if you want to override the default header.
   */
  modalHeader?: string;
  /**
   * Modal message shown to user.
   * Only provide this value if you want to override the implied modal message.
   */
  modalMessage?: string;
}

export interface IModalProps extends IBaseProps {
  allowsDismiss?: boolean;
  invertedCloseButton?: boolean;
  onDismiss?: () => void;
  size?: ModalSize;
  closeButton?: React.ElementType;
  amplitudeEventData: IAmplitudeEventData;
  height?: string;
  headerVariant?: 'headerOne' | 'headerTwo' | 'headerThree' | 'headerFour';
  headerHasBorderBottom?: boolean;
  isFullHeightContent?: boolean;
  skipLoggingHeaderAndMessage?: boolean;
  backgroundColor?: string;
  backgroundImage?: string;
  header?: React.ReactNode;
  footer?: React.ReactNode;
  body?: React.ReactNode;
  contentStyle?: any;
  headerStyle?: any;
  isErrorModal?: boolean;
  hideStatusBar?: boolean;
  scrollViewBounces?: boolean;
  closeButtonStyle?: any;
  withScroll?: boolean;
  // prevent issues when using with expo-router inside modals where it comes over the top of the modal
  isInline?: boolean;
  headerTextIsBelowCloseButton?: boolean;
  // Not all versions of the modal work the same way right now. While we're finding a better way to fix this, this setting lets us hide the floating button in some versions.
  isDismissButtonAbsolute?: boolean;
  additionalLoggingContext?: Object;
}

export interface IModalScreenProps extends IModalProps {
  // Render header prop on ReactNavigation ModalScreen. Default: false
  showFixedHeader?: boolean;
}
